import React, { useState, useEffect } from "react";
import VideoLinkForm from "./VideoLinkForm";
import ConfirmDialog from "../../../utils/ConfirmDialog";

const API_URL = "https://kvrstarlightmedicalacademy.com/api/videos.php";

const VideoLinkManager = () => {
  const token = localStorage.getItem("token");
  const [records, setRecords] = useState([]);
  const [view, setView] = useState("grid");
  const [editData, setEditData] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const showData = async () => {
    try {
      const response = await fetch(API_URL);
      const data = await response.json();
      setRecords(data);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    showData();
  }, []);

  const handleCreate = () => {
    setEditData(null);
    setView("form");
  };

  const handleEdit = (record) => {
    setEditData(record);
    setView("form");
  };

  const handleSubmit = async (formData) => {
    try {
      if (formData.id) {
        await fetch(`${API_URL}?id=${formData.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        });
      } else {
        await fetch(API_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        });
      }
      await showData();
      setView("grid");
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await fetch(`${API_URL}?id=${deleteId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      await showData();
    } catch (err) {
      console.error("Delete error:", err);
    }
    setConfirmOpen(false);
    setDeleteId(null);
  };

  return (
    <div className="container mt-4">
      <section className="content container-fluid mt-4">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-sm-12 col-lg-offset-2">
            <div className="box box-primary">
              <div className="box-header with-border d-flex justify-content-between align-items-center">
                {view === "grid" ? (
                  <>
                    <h3>Video Links</h3>
                    <button className="btn btn-primary" onClick={handleCreate}>
                      Add Video
                    </button>

                    <table className="table table-bordered mt-3">
                      <thead className="thead-dark">
                        <tr>
                          <th>#</th>
                          <th>Title</th>
                          <th>URL</th>
                          <th style={{ width: "180px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {records.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center text-muted">
                              No video links found.
                            </td>
                          </tr>
                        ) : (
                          records.map((item, index) => (
                            <tr key={item.id || index}>
                              <td>{index + 1}</td>
                              <td>{item.title}</td>
                              <td>
                                <a
                                  href={item.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {item.url}
                                </a>
                              </td>
                              <td>
                                <button
                                  className="btn btn-sm btn-warning mr-2"
                                  onClick={() => handleEdit(item)}
                                >
                                  Edit
                                </button>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => handleDelete(item.id)}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <VideoLinkForm
                    data={editData}
                    onSubmit={handleSubmit}
                    onCancel={() => setView("grid")}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {confirmOpen && (
        <ConfirmDialog
          message="Are you sure you want to delete this video link?"
          onConfirm={confirmDelete}
          onCancel={() => setConfirmOpen(false)}
        />
      )}
    </div>
  );
};

export default VideoLinkManager;
